export const generateUUID = (): string => Math.random().toString(36).substring(2, 15)
